import { takeEvery, call, put, all, fork, select } from "redux-saga/effects";
import {
  CREATE_TASK,
  PUT_TASKS,
  actionCreators,
  SAVE_TASK,
  CREATE_PROJECT
} from "./action";
import { reduxSagaFirebase } from "../../rootFirebase";
import { actionCreators as actionCreatorsTaskList } from "../TasksList/action";
import { actionCreators as actionCreatorsCreateTask } from "../CreateTask/action";
import { user } from "../../selectors/user";

import { CATEGORY } from '../TasksList/constants';
import { push } from 'connected-react-router';

export function* onCreateTaskSaga(action) {
  const isNext = action.payload.action === CATEGORY.NEXT;
  const isAction = action.payload.action === CATEGORY.WAITING;
  const isScheduled = action.payload.action === CATEGORY.SCHEDULED;
  const isSomeday = action.payload.action === CATEGORY.SOMEDAY;
  const isFocus = action.payload.action === CATEGORY.FOCUS;
  const newTask = {
    ...action.payload,
    id: 1,
    focus: false,
    reference: "firma",
    date: "10.10.2020",
    energy: "low",
    done: false,
    project: false, 
  };

  yield put(actionCreatorsTaskList.addTask({...newTask, unsaved: true}));

  const userId = yield select(user);
  const idNewTask = yield call(
    reduxSagaFirebase.database.create,
    `tasks/${userId}/`,
    newTask
  );

  yield call(reduxSagaFirebase.database.patch, `tasks/${userId}/${idNewTask}`, {
    id: idNewTask
  });
 
  yield put(actionCreatorsTaskList.fetchTasks());
  yield put(push('/next'));

}

export function* onCreateProjectSaga(action) {
  const newProject = {
    ...action.payload,
    id: 1,
    focus: false,
    reference: "firma",
    date: "10.10.2020",
    energy: "low",
    done: false,
    project: true,
    parent: null
  };
  const userId = yield select(user);
  
  const idNewProject = yield call(
    reduxSagaFirebase.database.create,
    `tasks/${userId}/`,
    newProject
  );
  
  yield call(reduxSagaFirebase.database.patch, `tasks/${userId}/${idNewProject}`, {
    id: idNewProject
  });

  yield put(actionCreatorsTaskList.fetchTasks());
}

export function* onSaveTaskSaga(action) {
  const editedTask = {
    ...action.payload
  };

  const taskId = action.payload.id;

  yield put(actionCreatorsTaskList.patchTask(action.payload));

  const userId = yield select(user);
  yield call(reduxSagaFirebase.database.patch, `tasks/${userId}/${taskId}`, {
    ...editedTask
  });

  yield put(actionCreatorsTaskList.fetchTasks());
  yield put(actionCreatorsCreateTask.closeTaskForm());
}

export function* createTask() {
  yield takeEvery(CREATE_TASK, onCreateTaskSaga);
}

export function* createProject() {
  yield takeEvery(CREATE_PROJECT, onCreateProjectSaga);
}

export function* saveTask() {
  yield takeEvery(SAVE_TASK, onSaveTaskSaga);
}

export function* newTaskForm() {
  yield all([fork(createTask), fork(saveTask), fork(createProject)]);
}
